import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ArrowRight } from "lucide-react";

export const AnnouncementBar = () => {
  const { data: settings, isLoading } = useQuery({
    queryKey: ['announcement-bar-settings'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('site_settings')
        .select('key, value')
        .in('key', [
          'announcement_bar_text', 
          'announcement_bar_link', 
          'announcement_bar_visible',
          'announcement_bar_bg_color',
          'announcement_bar_text_color'
        ]);

      if (error) throw error;
      
      const settingsMap: Record<string, string> = {};
      data?.forEach((s) => {
        settingsMap[s.key] = s.value;
      });
      return settingsMap;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  // Don't render anything while loading to prevent flicker
  if (isLoading) {
    return null;
  }

  // Check if announcement bar should be visible
  const isVisible = settings?.["announcement_bar_visible"] !== 'false';
  
  if (!isVisible) {
    return null;
  }

  const text = settings?.["announcement_bar_text"] || '🏠 Get An Instant Estimate - Free & Fast!';
  const link = settings?.["announcement_bar_link"] || 'https://app.roofmammoth.ai/embed/ffd7c692-cdc0-43e6-9164-78745be5de13';
  const bgColor = settings?.["announcement_bar_bg_color"] || '#b91c1c';
  const textColor = settings?.["announcement_bar_text_color"] || '#ffffff';

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="block py-2 transition-opacity hover:opacity-90"
      style={{ backgroundColor: bgColor }}
    >
      <div className="container mx-auto px-4">
        <div 
          className="flex items-center justify-center gap-2 font-semibold text-sm md:text-base"
          style={{ color: textColor }}
        >
          <span>{text}</span>
          <ArrowRight className="w-4 h-4" />
        </div>
      </div>
    </a>
  );
};
